import request from '@/router/axios'

export function fetchGoodsTypePage(params) {
  return request({
    url: '/mall/admin/goods-type/page',
    method: 'get',
    params
  })
}

export function addGoodsType(data) {
  return request({
    url: '/mall/admin/goods-type',
    method: 'post',
    data
  })
}

export function editGoodsTypeById(data) {
  return request({
    url: '/mall/admin/goods-type',
    method: 'put',
    data
  })
}

export function removeGoodsTypeById(id) {
  return request({
    url: `/mall/admin/goods-type/${id}`,
    method: 'delete'
  })
}

export function fetchGoodsTypeList() {
  return request({
    url: '/mall/admin/goods-type/all',
    method: 'get'
  })
}

export function syncGoodsTypeCache() {
  return request({
    url: '/mall/admin/goods-type/sync-cache',
    method: 'put',
  })
}